
export interface ConfigurationSets {
  configurationSets: ConfigurationSet[];
}

export interface ConfigurationSet {
  id: string;
  name: string;
  description: string;
  details: ConfigurationSetDetail[];
}

export interface NumberRange {
  minimum?: number;
  maximum?: number;
  exclusiveMinimum?: boolean;
  exclusiveMaximum?: boolean;
}

export interface ConfigurationSetDetail {
  label: string,
  configurationItemKey: string,
  description: string,
  type: string,
  default?: string,
  range?: string,
  value?: string,
  changed?: boolean,
}

export interface GeoprocessingServiceSettings {
  geoprocessingServerUrl: string;
}

export enum DatabaseType {
  ORACLE = "Oracle",
  SQLSERVER = "MSSql",
  POSTGIS = "PostGIS",
}

export interface DatabaseFeature {
  id: number,
  primaryFeature: boolean,
  featureName: string,
  dataType: string,
  displayName?: string
}

export interface DBConnectionConfig {
  id: string;
  connectionName: string;
  oracleServiceName?: string;
  oracleSid?: string;
  postgreSqlDatabase?: string;
  mssqlDatabase?: string;
  mssqlInstanceName?: string;
  serverDefaultSrs: string;
  serverName: string;
  serverUsername: string;
  type: DatabaseType;
  databaseTable: string;
  spatialColumn: string;
  serverPort: number;
  serverPassword: string;
  serverQueryTimeout: number;
  databaseFeatures: DatabaseFeature[];
  bounds: string;
  selectionTables: string;
  selectionFilter: string;
  maxCacheSize: number;
  alwaysCloseConnection: boolean;
  geometryType: string;
  dropBeforeCreatingTable: boolean;
}

export const DEFAULT_DB_PORTS = {
  [DatabaseType.ORACLE]: 1521,
  [DatabaseType.SQLSERVER]: 1433,
  [DatabaseType.POSTGIS]: 5432
};

export const DB_FILE_EXTENSION = {
  [DatabaseType.ORACLE]: "ora",
  [DatabaseType.SQLSERVER]: "mss",
  [DatabaseType.POSTGIS]: "pgs"
};

export const DB_DRIVER = {
  [DatabaseType.ORACLE]: "oracle.jdbc.driver.OracleDriver",
  [DatabaseType.SQLSERVER]: "com.microsoft.sqlserver.jdbc.SQLServerDriver",
  [DatabaseType.POSTGIS]: "org.postgresql.Driver"
};

export const DB_PROTOCOL = {
  [DatabaseType.ORACLE]: "jdbc:oracle:thin:@",
  [DatabaseType.SQLSERVER]: "jdbc:sqlserver://",
  [DatabaseType.POSTGIS]: "jdbc:postgresql://"
};

const BASE_EMPTY_DB_CONNECTION = {
  id: null,
  connectionName: "",
  oracleServiceName: "",
  oracleSid: "",
  postgreSqlDatabase: "",
  mssqlDatabase: "",
  mssqlInstanceName: "",
  serverDefaultSrs: "",
  serverName: "",
  serverUsername: "",
  databaseTable: "",
  spatialColumn: "",
  serverPassword: "",
  serverQueryTimeout: 0,
  databaseFeatures: [],
  bounds: "",
  selectionTables: "",
  selectionFilter: "",
  maxCacheSize: 100,
  alwaysCloseConnection: undefined,
  geometryType: "",
  dropBeforeCreatingTable: true
};

export const EMPTY_ORACLE_DB_CONNECTION: DBConnectionConfig = {
  ...BASE_EMPTY_DB_CONNECTION,
  type: DatabaseType.ORACLE,
  serverPort: DEFAULT_DB_PORTS[DatabaseType.ORACLE],
};

export const EMPTY_POSTGIS_DB_CONNECTION: DBConnectionConfig = {
  ...BASE_EMPTY_DB_CONNECTION,
  type: DatabaseType.POSTGIS,
  serverPort: DEFAULT_DB_PORTS[DatabaseType.POSTGIS],
};

export const EMPTY_SQLSERVER_DB_CONNECTION: DBConnectionConfig = {
  ...BASE_EMPTY_DB_CONNECTION,
  type: DatabaseType.SQLSERVER,
  serverPort: DEFAULT_DB_PORTS[DatabaseType.SQLSERVER],
};